import { render, staticRenderFns } from "./detaille.vue?vue&type=template&id=f9fffba6&scoped=true&"
import script from "./detaille.vue?vue&type=script&lang=js&"
export * from "./detaille.vue?vue&type=script&lang=js&"
import style0 from "./detaille.vue?vue&type=style&index=0&id=f9fffba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fffba6",
  null
  
)

export default component.exports